import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { ProductDefault } from '../subcomponents/product-default/ProductDefault';
import { ProductPodDefaultProps, ProductPodPropTypes } from '../Helper';
import { productPodDefaultDataModel } from '../dataModel';
import { ProductPodDefaultMobile } from './ProductPodDefaultMobile';
import { ProductPodDefaultDesktop } from './ProductPodDefaultDesktop';

export const ProductPodDefault = (props) => {
  const { channel } = useContext(ExperienceContext);
  const { props: themeProps } = useTheme(ProductPodDefault);
  const allProps = { ...props, ...themeProps };

  if (channel === 'mobile') {
    /* eslint-disable react/jsx-props-no-spreading */
    return <ProductPodDefaultMobile {...allProps} />;
  }
  /* eslint-disable react/jsx-props-no-spreading */
  return <ProductPodDefaultDesktop {...allProps} />;
};

ProductPodDefault.propTypes = ProductPodPropTypes;

ProductPodDefault.defaultProps = ProductPodDefaultProps;

ProductDefault.displayName = 'ProductDefault';

ProductPodDefault.dataModel = productPodDefaultDataModel;
